import { render, staticRenderFns } from "./breadcrumb.component.vue?vue&type=template&id=2fa83da2"
import script from "./breadcrumb.component.vue?vue&type=script&lang=js"
export * from "./breadcrumb.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports